import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';
import { filter } from 'rxjs/internal/operators/filter';

@Component({
	selector: 'app-proctoring-sidebar',
	standalone: true,
	imports: [CommonModule, RouterModule, MatIconModule, HasPermissionDirective],
	templateUrl: './proctoring-sidebar.component.html',
	styleUrl: './proctoring-sidebar.component.scss'
})
export class ProctoringSidebarComponent implements OnChanges, OnInit {

	@Input() isCollapsed = false;
	@Input() activeTab = 'dashboard';

	@Output() activeTabChange = new EventEmitter<string>();
	@Output() toggleCollapse = new EventEmitter<void>();
	@Output() logout = new EventEmitter<void>();
	showRuleMenu = false;
	PermissionForStudents = PermissionForStudents;


	constructor(
		private router: Router
	) { }


	ngOnInit(): void {
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
			const url = this.router.url;
			this.showRuleMenu =
				url.startsWith('/proctoring-dashboard/proto-configs') ||
				url.startsWith('/proctoring-dashboard/proto-rules');
		});
	}


	ngOnChanges(): void {
		this.showRuleMenu = this.activeTab === 'proto-rules' || this.activeTab === 'proto-configs';
	}


	selectTab(tab: string): void {
		this.activeTabChange.emit(tab);
	}

	onToggleCollapse(): void {
		this.toggleCollapse.emit();
	}

	onLogout(): void {
		this.logout.emit();
	}


	toggleRuleMenu(): void {
		this.showRuleMenu = !this.showRuleMenu;
		if (this.showRuleMenu) {
			this.selectTab('proto-configs');
		}
	}

}
